import React from "react";

const ProgresoResumen = ({ vistos, total }) => {
  if (!total) return null;
  const porcentaje = Math.round((vistos / total) * 100);

  return (
    <div className="orgproc-progreso">
      <p className="orgproc-progreso-texto">
        {vistos} de {total} videos vistos
      </p>
      <div className="orgproc-progreso-barra">
        <div className="orgproc-progreso-relleno" style={{ width: `${porcentaje}%` }} />
      </div>
    </div>
  );
};

export default ProgresoResumen;
